import { render } from "./PaperPath.vue?vue&type=template&id=019ef9be&scoped=true"
import script from "./PaperPath.vue?vue&type=script&lang=js"
export * from "./PaperPath.vue?vue&type=script&lang=js"

import "./PaperPath.vue?vue&type=style&index=0&id=019ef9be&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019ef9be"]])

export default __exports__